import { useEffect, useState } from "react";
import {
  Typography,
  Row,
  Col,
  Input,
  InputNumber,
  Select,
  Alert,
  notification,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setAllCompanyNames } from "../../redux/actions/mainAction";
import { setTriggerAnyEvent } from "../../redux/actions/globalAction";

const AddMeetingRoom = () => {
  const [meetingRoomName, setMeetingRoomName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [meetingRoomSize, setMeetingRoomSize] = useState();
  const [meetingRoomEmail, setMeetingRoomEmail] = useState("");
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");

  const [showAlert, setShowAlert] = useState(false);
  const [showPassworAlert, setShowPasswordAlert] = useState(false);
  const [showPasswordLengthAlert, setShowPasswordLengthAlert] = useState(false);
  const [showAlertAvailableEmail, setShowAlertAvailableEmail] = useState(false);
  const [showAlertIncorrectEmail, setShowAlertIncorrectEmail] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);

  const { GlobalResponse } = useSelector((state) => state);
  const { MainResponse } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    getAllCompanyNames();
  }, [GlobalResponse.triggeranyevent]);

  const openNotificationWithIcon = (type) => {
    api[type]({
      message: "Otaq əlavə edildi!",
    });
  };

  const getAllCompanyNames = async () => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/get-company-names/`,
      {
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();
    const uniqueResults = result.filter((item, index, array) => {
      return array.findIndex((obj) => obj.value === item.value) === index;
    });
    dispatch(setAllCompanyNames(uniqueResults));
  };

  const handleChangeCompany = (value) => {
    setCompanyName(value);
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const prepareTosaveMeetingRoom = () => {
    if (isValidEmail(meetingRoomEmail)) {
      if (password.length > 5) {
        saveMeetingRoom();
      } else {
        setShowPasswordLengthAlert(true);
        setShowPasswordAlert(false);
      }
    } else {
      setShowAlertIncorrectEmail(true);
      setShowPasswordLengthAlert(false);
    }
  };

  const saveMeetingRoom = async () => {
    if (
      meetingRoomName &&
      companyName &&
      meetingRoomSize &&
      typeof meetingRoomSize !== "String" &&
      meetingRoomEmail &&
      password &&
      repeatPassword
    ) {
      if (password === repeatPassword) {
        setShowAlert(false);
        setButtonDisable(true);

        let result = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/add-meetingroom/`,
          {
            method: "post",
            body: JSON.stringify({
              meetingRoomName,
              companyName,
              meetingRoomSize,
              meetingRoomEmail,
              password,
            }),
            headers: {
              "Content-Type": "application/json",
              authorization: `bearer ${JSON.parse(
                localStorage.getItem("token")
              )} `,
            },
          }
        );
        // result = await result.json();
        if (result.ok) {
          dispatch(setTriggerAnyEvent(Math.random()));
          setMeetingRoomName("");
          setCompanyName("");
          setMeetingRoomSize();
          setMeetingRoomEmail("");
          setPassword("");
          setRepeatPassword("");
          openNotificationWithIcon("success");
          setShowAlertAvailableEmail(false);
          setShowAlert(false);
          setShowPasswordAlert(false);
          setShowPasswordLengthAlert(false);
          setShowAlertIncorrectEmail(false);
          setButtonDisable(true);
        } else {
          setShowAlertAvailableEmail(true);
        }
      } else {
        setShowAlert(false);
        setShowPasswordLengthAlert(false);
        setShowPasswordAlert(true);
      }
    } else {
      setShowAlert(true);
      setShowPasswordLengthAlert(false);
      setShowPasswordAlert(false);
    }
  };

  return (
    <>
      {contextHolder}

      {showAlert && (
        <Alert
          onClose={() => setShowAlert(false)}
          message="Diqqət!"
          description="Zəhmət olmasa boş sahələri doldurun!"
          type="warning"
          showIcon
          closable
        />
      )}
      {showPassworAlert && (
        <Alert
          onClose={() => setShowAlert(false)}
          message="Diqqət!"
          description="Şifrələriniz eyni deyil!"
          type="warning"
          showIcon
          closable
        />
      )}
      {showPasswordLengthAlert && (
        <Alert
          onClose={() => setShowAlert(false)}
          message="Diqqət!"
          description="Şifrə 5 simvoldan çox olmalıdır!"
          type="warning"
          showIcon
          closable
        />
      )}
      {showAlertAvailableEmail && (
        <Alert
          onClose={() => setShowAlertAvailableEmail(false)}
          message="Diqqət!"
          description="Bu e-poçt hesabı artıq qeydiyyatdan keçirilib!"
          type="warning"
          showIcon
          closable
        />
      )}
      {showAlertIncorrectEmail && (
        <Alert
          onClose={() => setShowAlertIncorrectEmail(false)}
          message="Diqqət!"
          description="E-poçt hesabında səhv var!"
          type="warning"
          showIcon
          closable
        />
      )}
      <Row className="add-row">
        <Col span={6}>
          <Typography.Text className="add-title">Otağın adı</Typography.Text>
          <Input
            className="add-input"
            size="large"
            value={meetingRoomName}
            onChange={(e) => setMeetingRoomName(e.target.value)}
          />
        </Col>
        <Col span={6}>
          <Typography.Text className="add-title">Şirkət</Typography.Text>

          <Select
            size="large"
            value={companyName}
            onChange={handleChangeCompany}
            className="add-dropdown"
            options={MainResponse.allCompanyNames}
          />
        </Col>

        <Col span={6}>
          <Typography.Text className="add-title">Otağın tutumu</Typography.Text>
          <InputNumber
            className="add-input"
            size="large"
            onChange={(value) => setMeetingRoomSize(value)}
            value={meetingRoomSize}
            min={1}
            max={700}
          />
        </Col>

        <Col span={6}>
          <Typography.Text className="add-title">E-poçt</Typography.Text>
          <Input
            className="add-input"
            size="large"
            value={meetingRoomEmail}
            onChange={(e) =>
              setMeetingRoomEmail(e.target.value.toLowerCase().trim())
            }
          />
        </Col>
      </Row>

      <Row className="add-row">
        <Col span={8}>
          <Typography.Text className="add-title">
            Otaq cihazının şifrəsi
          </Typography.Text>
          <Input.Password
            className="add-input"
            size="large"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
          />
        </Col>

        <Col span={8}>
          <Typography.Text className="add-title">
            Şifrənin təkrarı
          </Typography.Text>
          <Input.Password
            className="add-input"
            size="large"
            value={repeatPassword}
            onChange={(e) => setRepeatPassword(e.target.value)}
            type="password"
          />
        </Col>

        <Col span={8}>
          <button
            disabled={buttonDisable}
            onClick={prepareTosaveMeetingRoom}
            className="add-button"
          >
            Əlavə Et
          </button>
        </Col>
      </Row>
    </>
  );
};

export default AddMeetingRoom;
